import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { IState } from 'store';
import { ICardsProps } from 'utils/cards';
import { IConfigApplicationProps } from 'store/modules/config';

interface CardItemMobileProps {
  item: any;
  index: number;
}

export default function CardItemMobile({ item, index }: CardItemMobileProps) {
  const { ultraDescontao, seloLivre } = useSelector<
    IState,
    IConfigApplicationProps
  >(state => state.config.config);

  const [itemList, setItemList] = useState<ICardsProps>({} as ICardsProps);

  useEffect(() => {
    if (item.name === 'UltraDesconto') {
      const painelItem = {
        url: ultraDescontao?.seloPdpUrl,
        urlExpanded: ultraDescontao?.seloVitrineUrl,
        urlExpandedFull: ultraDescontao?.seloVitrineUrl,
        urlExpandedMobile: ultraDescontao?.seloMobileExpandidoUrl,
      } as ICardsProps;

      setItemList({ ...item, ...painelItem });
    } else if (item.name === 'SeloLivre') {
      const painelItem = {
        url: seloLivre?.seloLivreUrl,
        urlExpanded: seloLivre?.seloLivreExpandido,
        urlExpandedFull: seloLivre?.seloLivreExpandido,
        urlExpandedMobile: seloLivre?.seloLivreExpandidoMobile,
      } as ICardsProps;

      setItemList({ ...item, ...painelItem });
    } else {
      setItemList(item);
    }
  }, [item, ultraDescontao, seloLivre]);

  return (
    <>
      <img
        src={itemList.urlExpandedMobile}
        alt={itemList.name}
        key={index}
        className={itemList.name}
      />
    </>
  );
}
